export class BillCheckCreationFlowError extends Error {
  readonly type: string;
  constructor() {
    super('BillCheck creation flow error');
    this.type = 'BillCheckCreationFlowError';
  }
}
